import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { Span, semanticCSS } from '../../../typography/semanticTags';

const componentConfigThemeKey = 'menuIcon';


interface AMPMenuIconThemeProps {
  color: string
}

interface AMPMenuIconDataProps {
}

type AMPMenuIconComponentProps = AMPMenuIconDataProps & AMPMenuIconThemeProps;

const getMenuIconStyle = (color: string) => StyleSheet.create({
  wrapper: {
    width: '16px',
    height: '16px',
    position: 'relative',
    cursor: 'pointer',
    [MEDIA_BREAKPOINTS.LARGE]: {
      display: 'none',
    },
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      display: 'inline-flex',
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      display: 'inline-flex',
    },
    ':focus': {
      outline: 'none',
    },
  },
  span: {
    display: 'block',
    position: 'absolute',
    backgroundColor: color,
    height: '2px',
    width: '100%',
    opacity: 1,
    left: 0,
  },
  firstSpanClose: {
    top: 0,
  },
  secondSpanClose: {
    top: '7px',
  },
  thirdSpanClose: {
    top: '14px',
  },
});


export const AMPMenuIconComponent: React.FunctionComponent<AMPMenuIconComponentProps> = ({ color }) => {
  const menuIcon = getMenuIconStyle(color);
  return (
    // @ts-ignore
    <div tabIndex="0" on="tap:sidebar.open" role="button" className={css(menuIcon.wrapper)}>
      <Span styles={semanticCSS(menuIcon.span, menuIcon.firstSpanClose)} />
      <Span styles={semanticCSS(menuIcon.span, menuIcon.secondSpanClose)} />
      <Span styles={semanticCSS(menuIcon.span, menuIcon.thirdSpanClose)} />
    </div>
  );
};

const mapThemeProps = (theme: AMPMenuIconThemeProps) => {
  return {
    color: theme.color,
  };
};

export const AMPMenuIcon = (props: AMPMenuIconDataProps) => {
  const themeContext = useTheme(mapThemeProps, componentConfigThemeKey);
  return <ErrorBoundary><AMPMenuIconComponent {...themeContext} {...props} /></ErrorBoundary>;
};
